// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import { ColorPicker } from 'primereact/colorpicker';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"


export const ViewshedAnalysisComponents = (props) => {
    const [color, setColor] = useState("");
    const [viewshedRange, setViewshedRange] = useState(0);
    const [posX, setPosX] = useState(0);
    const [posY, setPosY] = useState(0);
    const [posZ, setPosZ] = useState(0);
    const toast = useRef(null);


    useEffect(() => {
        setColor(props.ViewshedAnalysisSetting.color);
        setViewshedRange(props.ViewshedAnalysisSetting.viewshedRange);
        setPosX(props.ViewshedAnalysisSetting.posX);
        setPosY(props.ViewshedAnalysisSetting.posY);
        setPosZ(props.ViewshedAnalysisSetting.posZ);
    }, []);

    useEffect(() => {
        let setting = {
            color: color,
            viewshedRange: viewshedRange,
            posX: posX,
            posY: posY,
            posZ: posZ
        }
        props.setViewshedAnalysisSetting(setting);
    }, [color, viewshedRange, posX, posY, posZ])

    const posClick = () => {
        let _analysis = window.main.OView.findLayer("analysis");
        if (_analysis === null) {
            _analysis = window.main.OView.addCustomLayer({
                layername: "analysis"
            });
        }
        else {
            _analysis.removeAllEntity();
        }
        if (window.main !== null) {
            window.main.OView.analysis.ClearViewshedAnalysis();
            window.main.OView.cursor = 'crosshair';
            toast.current.show({ severity: 'info', summary: '分析資訊', detail: '選定中心點並拉開可視範圍的圓' });
            window.main.OView.inputCircle({}, function (e) {
                if (e.success) {
                    window.main.OView.cursor = 'default';
                    let param = {};
                    param.geo = new window.GeoPoint(e.geo.center.x, e.geo.center.y, e.geo.center.z + 5);//幾何
                    param.color = "#FF0000";//紅色
                    param.opacity = 0.8;//不透明
                    param.size = 15;//大小
                    param.absHeight = true; //是否為絕對高              
                    _analysis.addPointEntity(param);
                    setViewshedRange(e.geo.radius);
                    setPosX(e.geo.center.x);
                    setPosY(e.geo.center.y);
                    setPosZ(e.geo.center.z + 2);
                }
                else {
                    window.main.OView.cursor = 'default';
                    toast.current.show({ severity: 'error', summary: '分析資訊', detail: '設定座標失敗' });
                }
            });
        }
    }

    const startAnalysis = () => {
        if (window.main !== null) {
            let ViewshedCenter = new window.GeoPoint(
                posX,
                posY,
                posZ
            );
            let _analysis = window.main.OView.findLayer("analysis");
            if (_analysis === null) {
                _analysis = window.main.OView.addCustomLayer({
                    layername: "analysis"
                });
            }
            else {
                _analysis.removeAllEntity();
            }
            let param = {};
            param.geo = new window.GeoPoint(posX, posY, posZ + 3);//幾何
            param.color = "#FF3300";//紅色
            param.opacity = 0.8;//不透明
            param.size = 15;//大小
            param.absHeight = true; //是否為絕對高              
            _analysis.addPointEntity(param);
            let ViewshedRange = viewshedRange;
            let ViewshedColor = "#" + color;
            window.main.OView.analysis.viewshedAnalysis({
                center: ViewshedCenter,
                distance: ViewshedRange,
                absHeight: true,
                color: ViewshedColor,
                opacity: 1.0,
                epsg: null
            });
        }
    }

    const clearAnalysis = () => {
        if (window.main !== null) {
            window.main.OView.abortInput();
            window.main.OView.analysis.ClearViewshedAnalysis();
            let _analysis = window.main.OView.findLayer("analysis");
            if (_analysis !== null) {
                _analysis.removeAllEntity();
            }
        }
    }

    return (
        <div>
            <Toast ref={toast} />
            <div className="field grid">
                <label htmlFor="coverDropdown" class="col-12 mb-4 md:col-4 md:mb-0">可視範圍顏色</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <ColorPicker value={color} onChange={(e) => setColor(e.value)} ></ColorPicker>
                </div>
            </div>
            <div className="field grid">
                <label htmlFor="viewshedRange" class="col-12 mb-4 md:col-4 md:mb-0">範圍</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <InputNumber inputId="viewshedRange" value={viewshedRange} onValueChange={(e) => setViewshedRange(e.value)} mode="decimal" maxFractionDigits={6} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label htmlFor="posX" class="col-12 mb-4 md:col-4 md:mb-0">中心X座標</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <InputNumber inputId="posX" value={posX} onValueChange={(e) => setPosX(e.value)} mode="decimal" maxFractionDigits={6} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label htmlFor="posY" class="col-12 mb-4 md:col-4 md:mb-0">中心Y座標</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <InputNumber inputId="posY" value={posY} onValueChange={(e) => setPosY(e.value)} mode="decimal" maxFractionDigits={6} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <label htmlFor="posZ" class="col-12 mb-4 md:col-4 md:mb-0">中心Z座標</label>
                <div className="col-12 md:col-8" style={{ alignSelf: 'center' }}>
                    <InputNumber inputId="posZ" value={posZ} onValueChange={(e) => setPosZ(e.value)} mode="decimal" maxFractionDigits={6} style={{ width: "100%" }} />
                </div>
            </div>
            <div className="field grid">
                <div className="col-12 md:col-4" style={{ alignSelf: 'center' }}>
                    <Button label="設定座標" icon="pi pi-map-marker" className="p-button-rounded p-button-warning" onClick={posClick} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-4" style={{ alignSelf: 'center' }}>
                    <Button label="開始" icon="pi pi-check" className="p-button-rounded p-button-info" onClick={startAnalysis} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-4" style={{ alignSelf: 'center' }}>
                    <Button label="清除" icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={clearAnalysis} style={{ width: "100%" }} />
                </div>
            </div>
        </div>
    )
}